import { BaseController } from '../../utilities/base_controller';
export class PrintController extends BaseController {
    print(event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        window.print();
    }
}
